import { assocPath, flatten, isNil, reduce, values } from 'ramda';
export const flattenObjectValuesToArray = (obj) => {
    const flattenRecursive = (input) => {
        if (input == null)
            return [];
        if (typeof input === 'object') {
            return flatten(values(input).map(flattenRecursive));
        }
        return [String(input)];
    };
    return flattenRecursive(obj);
};
export const apiErrorsToFormikErrors = (errors) => {
    if (isNil(errors))
        return {};
    return reduce((acc, key) => assocPath(key.split('.'), errors[key], acc), {}, Object.keys(errors));
};
